import { AccessPointForProjection } from "@app/projects/results/projection-provider";
import { BulkProviderChangeProjectTableData } from "@app/shared/provider-change-wizards/interfaces";
import ProjectionProviderService from "@app/projects/projection-provider/projectionProviderService";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { BulkProjectTypeEnum } from "@app/shared/enums/bulkProjectTypeEnum";

export enum AdvancedExclusionsWizardContextSteps {
  "SelectProject",
  "VerifiedSources",
  "Confirm"
}

export interface BulkProjectionSharedContextProps {
  projectionProviderService: ProjectionProviderService;
  projects: BulkProviderChangeProjectTableData[];
  selectedProjectIds: string[];

  setProjects: (projects: BulkProviderChangeProjectTableData[]) => void;
  setSelectedProjectIds: (ids: string[]) => void;
}

export class ExclusionVerifiedSources {
  static readonly verifiedSources: string[] = [
    "Physician Compare",
    "Hospital Compare",
    "Nursing Home Compare",
    "Dialysis Compare",
    "NPI file/NPPES",
    "Provider of Services (POS) Files",
    "Direct outreach to provider",
    "Provider Website",
    "State Licensing Data",
    "Online Mapping Tool",
    "CMS MA Supply File",
    "CMS MMP Supply File",
    "Other"
  ];
}

export interface AdvancedExclusionsWizardRouteState {
  currentProjectId: string;
  providerNetworkType: ProviderNetworkTypeEnum;
  selectedExclusionProviders: AccessPointForProjection[];
  specialtyGroup: string;
  projectType?: BulkProjectTypeEnum;
}